import React from 'react';
import {
  findValueById,
  toMoney,
  findBaustein,
  Shield,
  useGotoPage,
  If,
  istEnumAuswahl,
  EnumVorgangsart,
  trEnv,
  SummingUpButtonLink,
} from 'ion-lib';
import { useSelector } from 'react-redux';
import i18next from 'i18next';
import { istHausrat } from '../helper';
import { EnumGlasversicherung, EnumNeuordnung } from './enum';

const SummingupWarenkorb = ({
  nolink = false,
}) => {
  const gotoPage = useGotoPage();
  const zahlweise = useSelector((state) => state.daten.zahlweise);
  const versSumme = useSelector((state) => state.daten.versSumme);
  const bausteine = useSelector((state) => state.daten.bausteine);
  const auswahlBaustein = useSelector((state) => state.daten.auswahlBaustein);
  const auswahlVersicherung = findBaustein(bausteine, auswahlBaustein);
  const vorgangsart = useSelector((state) => state.daten.vorgangsart);
  const auswahlNeuordnung = useSelector((state) => state.daten.auswahlNeuordnung);
  const vsnrHausratAltFuerNeuordnung = useSelector((state) => state.daten.vsnrHausratAltFuerNeuordnung);
  const vsnrHausratGlasAltFuerNeuordnung = useSelector((state) => state.daten.vsnrHausratGlasAltFuerNeuordnung);

  const crossOrCheck = (value) => (value ? 'list-icn-checkbullet' : 'list-icn-cross');

  const bausteinList = [
    {
      show: auswahlVersicherung.glasversicherung.relevant && auswahlVersicherung.glasversicherung.ueberschreibbar,
      check: auswahlVersicherung.glasversicherung.value,
      component: (
        <ul className={crossOrCheck(auswahlVersicherung.glasversicherung.value)} key="glasversicherung">
          <li>
            {i18next.t('summingup.glas')}
          </li>
        </ul>
      ),
    },
    {
      show: auswahlVersicherung.fahrraddiebstahl.relevant && auswahlVersicherung.fahrraddiebstahl.ueberschreibbar,
      check: auswahlVersicherung.fahrraddiebstahl.value,
      component: (
        <ul className={crossOrCheck(auswahlVersicherung.fahrraddiebstahl.value)} key="fahrraddiebstahl">
          <li>
            {i18next.t('summingup.fahrrad')}
          </li>
        </ul>
      ),
    },
    {
      show: auswahlVersicherung.naturgefahren.relevant && auswahlVersicherung.naturgefahren.ueberschreibbar,
      check: auswahlVersicherung.naturgefahren.value,
      component: (
        <ul className={crossOrCheck(auswahlVersicherung.naturgefahren.value)} key="naturgefahren">
          <li>
            {i18next.t('summingup.natur')}
          </li>
        </ul>
      ),
    },
    {
      show: auswahlVersicherung.notfalldienste.relevant && auswahlVersicherung.notfalldienste.ueberschreibbar,
      check: auswahlVersicherung.notfalldienste.value,
      component: (
        <ul className={crossOrCheck(auswahlVersicherung.notfalldienste.value)} key="notfalldienste">
          <li>
            {i18next.t('summingup.notfall')}
          </li>
        </ul>
      ),
    },
  ].sort((a, b) => {
    if (a.check > b.check) {
      return -1;
    }
    if (a.check < b.check) {
      return 1;
    }

    return 0;
  });

  const glasliste = [
    (
      <ul className={crossOrCheck(true)} key="mobiliar">
        <li>Mobiliarverglasung</li>
      </ul>
    ),
    (
      <ul className={crossOrCheck(istEnumAuswahl(auswahlVersicherung.glasversicherungArt, EnumGlasversicherung.GEBAEUDE))} key="gebäude">
        <li>Gebäudeverglasung</li>
      </ul>
    ),
  ];

  return (
    <>
      {/* Neuordnung Hausrat */}
      <If predicate={istEnumAuswahl(auswahlNeuordnung, EnumNeuordnung.HAUSRAT)
          || istEnumAuswahl(auswahlNeuordnung, EnumNeuordnung.KOMBI)
          || (istEnumAuswahl(vorgangsart, EnumVorgangsart.NEUORDNUNG) && trEnv.ifiliale)}
      >
        <h4 className="text-center">
          Neuordnung zu VSNR
          {' '}
          {vsnrHausratAltFuerNeuordnung.value}
        </h4>
      </If>

      {/* Neuordnung Glas */}
      <If predicate={istEnumAuswahl(auswahlNeuordnung, EnumNeuordnung.GLAS) && vsnrHausratGlasAltFuerNeuordnung.value && !vsnrHausratGlasAltFuerNeuordnung.error}>
        <h4 className="text-center">
          Neuordnung zu VSNR
          {' '}
          {vsnrHausratGlasAltFuerNeuordnung.value}
        </h4>
      </If>

      <h4 className="text-center">
        Absicherung:
        {' '}
        {istHausrat() ? auswahlVersicherung.label.value : 'Glasversicherung'}
      </h4>
      <p className="text-center mt-3 mb-2">
        <If predicate={istHausrat()}>
          {istEnumAuswahl(vorgangsart, EnumVorgangsart.NEUORDNUNG) ? toMoney(auswahlVersicherung.bruttoBeitragHausrat.value) : toMoney(auswahlVersicherung.bruttoBeitrag.value)}
        </If>
        <If predicate={!istHausrat()}>
          {toMoney(auswahlVersicherung.bruttoBeitragGlas.value)}
        </If>
        {' '}
        /
        {' '}
        {findValueById(zahlweise.valueSet, zahlweise.value)}
      </p>

      {versSumme.relevant && (
        <ul className="list-icn-checkbullet">
          <li>
            Versicherungssumme:
            {' '}
            {`${parseFloat(versSumme.value).toLocaleString('de-DE')} €`}
          </li>
        </ul>
      )}

      {istHausrat() ? bausteinList.map((elem) => elem.show && elem.component) : glasliste.map((elem) => elem)}

      {/* Neuordnung Hausrat und Glas */}
      <If predicate={istEnumAuswahl(auswahlNeuordnung, EnumNeuordnung.KOMBI)}>
        <hr />
        <h4 className="text-center">
          Neuordnung zu VSNR
          {' '}
          {vsnrHausratGlasAltFuerNeuordnung.value}
        </h4>

        <h4 className="text-center">
          Absicherung: Glasversicherung
        </h4>
        <p className="text-center mt-3 mb-2">
          {toMoney(auswahlVersicherung.bruttoBeitragGlas.value)}
          /
          {findValueById(zahlweise.valueSet, zahlweise.value)}
        </p>

        {glasliste.map((elem) => elem)}

      </If>

      {!nolink && (
        <SummingUpButtonLink
          onClick={() => gotoPage('Produktvergleich')}
          title="Produktauswahl ändern"
          icon={<Shield className="me-2" />}
        />
      )}
    </>
  );
};

export default SummingupWarenkorb;
